export const DAILY_ADD = 'DAILY_ADD';
